import { get } from "@green24/npm-javascript-utils";

const weekDayKeys = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];

export class LocationUtils {
	static getOpeningPeriodsForToday(location) {
		if(!location) return [];

		const now = new Date();
		const dayInWeek = now.getDay();
		const dayKey = weekDayKeys[dayInWeek];

		const dayData = get(location, "openingHours.entries", []).find(dayData => {
			if(dayData.weekday == dayKey) {
				return true;
			}
		});

		if(dayData.openingType == "NONSTOP") {
			return []
		}

		return dayData.periods.map(period => {
			let [fromHour, fromMinute] = period.fromTime.split(':');
			let [toHour, toMinute] = period.toTime.split(':');
			toHour = parseInt(toHour);
			toMinute = parseInt(toMinute);

			const fromDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), parseInt(fromHour), parseInt(fromMinute));
			const toDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + (toHour == 0 && toMinute == 0 ? 1 : 0), toHour, toMinute);

			return {
				from: period.fromTime,
				to: period.toTime,
				fromDate,
				toDate,
			}
		}).sort((a, b) => a.fromDate - b.fromDate);
	}
}
